import { useEffect, useState } from "react";
import { DaisyEurRates, getDaisyEurRates } from "../../api/getDaisyEurRates";

export default function DaisyEurRatesPage() {
    const [elements, setElements] = useState<DaisyEurRates[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true); // Start true to prevent UI flash

    useEffect(() => {
        const loadData = async () => {
            // 1. Try to get data from LocalStorage first
            const storedElements = localStorage.getItem('daisyEurRates');

            if (storedElements) {
                setElements(JSON.parse(storedElements));
                setIsLoading(false);
                // Optional: You might want to fetch in the background to update stale cache
                return; 
            }

            // 2. If no LocalStorage, fetch from API
            try {
                const res = await getDaisyEurRates();
                setElements(res);
                localStorage.setItem('daisyEurRates', JSON.stringify(res));
            } catch (error) {
                console.error("Failed to fetch rates:", error);
            } finally {
                setIsLoading(false);
            }
        };

        loadData();
    }, []); // Empty dependency array ensures this runs once on mount

    const getRadioValue = (value: string) => {
        switch (value) {
        case "Radio1":
            return "1. opció";
        case "Radio2":
            return "2. opció";
        case "Radio3":
            return "3. opció";
        default:
            return "Ismeretlen opció / Hiba történt";    
        }
    }

    const formatSignedDate = (dateString: string) => {
        return new Date(dateString).toLocaleDateString('hu-HU');
    }


    return (
        <div className="m-10">
            {isLoading ? (
                <div className="text-md font-semibold text-center">
                    Adatok betöltése...
                </div>
            ) : (
                <div className="flex flex-col gap-2">

                    {elements.length > 1 && (
                        <>
                            <p className="text-sm text-center text-gray-500">
                                Összesen <span className="font-semibold">{elements.length}</span> szerződés található, ebből <span className="font-semibold">{elements?.filter((elem) => elem.ok).length}</span> érvényes.
                            </p>
                            <p className="text-sm text-center text-gray-800">
                                Összesített kamat: {Math.round(elements.filter((elem) => elem.ok).reduce((acc, curr) => acc + curr.value?.interestRate, 0))} EUR
                            </p>

                            <button className="m-auto bg-dark-blue text-gray-200 px-2 py-2 rounded mb-5 hover:bg-gray-800 w-1/4">
                                Adatok frissítése és gyorsítótár ürítése
                            </button>
                        </>
                    )}

                    {elements.map((element, index) => (
                        /* ALWAYS add a unique key. If element has an ID, use element.id instead of index */
                        <div
                        key={index}
                        className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm hover:shadow-md transition-shadow"
                        >
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
                                <div>
                                <p className="text-gray-500">Név</p>
                                <p className="font-medium text-gray-900">
                                    {element.value?.signer.name}
                                </p>
                                </div>

                                <div>
                                <p className="text-gray-500">Email</p>
                                <p className="font-medium text-gray-900 break-all">
                                    {element.value?.signer.email}
                                </p>
                                </div>

                                <div>
                                <p className="text-gray-500">Aláírás dátuma</p>
                                <p className="font-medium text-gray-900">
                                    {formatSignedDate(element.value?.signedTime)}
                                </p>
                                </div>

                                <div>
                                <p className="text-gray-500">Választott opció</p>
                                <p className="font-medium text-gray-900">
                                    {getRadioValue(element.value?.radioValue)}
                                </p>
                                </div>

                                <div>
                                <p className="text-gray-500">Kifizetési csoport</p>
                                <p className="font-medium text-gray-900">
                                    {element.value?.yearCategory}
                                </p>
                                </div>

                                <div>
                                <p className="text-gray-500">Szerződésen szereplő összeg (EUR)</p>
                                <p className="font-semibold text-amber-600">
                                    {element.value?.diff}
                                </p>
                                </div>

                                <div>
                                <p className="text-gray-500">Eddigi kamat (EUR)</p>
                                <p className="font-semibold text-green-600">
                                    {Math.round(element.value?.interestRate)}
                                </p>
                                </div>
                            </div>
                        </div>

                    ))}
                    
                    {elements.length === 0 && !isLoading && (
                        <p>Nincs megjeleníthető adat.</p>
                    )}
                </div>
            )}
        </div>
    );
}